import React from "react";

export default function OmSymbol({ size = 24, className = "", style, ...props }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-flex items-center justify-center font-heading leading-none ${className}`}
      style={{ fontSize: size, width: size, height: size, color: "currentColor", ...style }}
      {...props}
    >
      ॐ
    </span>
  );
}
